<template>
  <div
    v-if="config && !userDisabled(identifier)"
    class="icon-row-container"
  >
    <dashboard-widget-header
      :title="config.name"
      :icon="widgetIcon"
      :free-items-count="freeItemsCount"
      :show-free-counts="showFreeCounts"
      :total-display-name="totalDisplayName"
      :total-items-count="totalItemsCount"
      :show-close="userHideable"
      @remove-requested="removeRequested(identifier)"
    />
    <div class="nav-link-container">
      <router-link
        v-for="item in navigationItems"
        :key="item.id"
        :to="item.route"
        @click="sendAnalytics(item)"
      >
        <div class="icon-container">
          <img
            :src="item.icon"
            role="presentation"
            alt=""
            aria-describedby="icon-name"
          >
        </div>
        <div
          id="icon-name"
          class="name"
        >
          {{ item.name }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import WidgetMixin from '@/mixins/widget';

export default {
  components: { DashboardWidgetHeader },
  mixins: [DashboardWidgetMixin, WidgetMixin],
  props: {
    config: {
      type: Object,
    },
    identifier: {
      type: Number,
    },
    userHideable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sendAnalytics(item) {
      this.$analytics.events.selectedNavItem(item, this.navigationGroup, this.config.widgetType);
      if (item.destination === 'catalog') {
        this.$analytics.events.viewedCatalogHomePage({ id: this.config.id, name: this.config.name, type: 'Widget' });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.icon-row-container {
  @include padded-widget;

  .nav-link-container {
    align-content: center;
    display: flex;

    @include breakpoint(small) {
      flex-wrap: wrap;
    }

    > a {
      padding: 0 32px 16px 0;
      text-align: center;

      @include breakpoint(small) {
        box-sizing: border-box;
        width: 50%;
      }
    }

  }

  .icon-container {
    background: #e8e8e8;
    border-radius: 100%;
    height: 48px;
    margin: auto;
    width: 48px;

    img {
      height: 24px;
      padding: 12px;
      width: 24px;
    }
  }

  .name {
    color: black;
    font-size: 14px;
    margin-top: 12px;
  }
}
</style>
